// extracted by mini-css-extract-plugin
export var apiTabContent = "api-tab-content_kLM3RTypmks6AtxtP008";
export var apiTabContentIncreasePadding = "api-tab-content_increase-padding_CTieS_qK4H6c7eRM7ylG";